module.exports = __webpack_public_path__ + "img/39.like.e8addd44.svg";